import { isUserAuthenticated } from "@/middleware/auth";
import { SocketEventActionType, MemberEventType } from "./types";
import { useNavigationState } from "@/zustand/NavigationState";
import { queryClient } from "@/queryClient";
import { updateChatInLocalDB } from "@/indexedDB/services/chats";

export const handleMemberEvent = async (data: MemberEventType) => {
  // extra check if auth is present
  const userFingerPrint = isUserAuthenticated();
  if (!userFingerPrint) {
    return;
  }

  switch (data.action) {
    case SocketEventActionType.CREATE:
      break;
    case SocketEventActionType.UPDATE:
      // TO DO => CHECK if needs syncing user avatar across all components
      await onUpdateMember({ eventPayload: data });
      break;
    case SocketEventActionType.DELETE:
      break;

    default:
      break;
  }
};

const onUpdateMember = async ({
  eventPayload,
}: {
  eventPayload: MemberEventType;
}) => {
  // extra check if auth is present
  const userFingerPrint = isUserAuthenticated();
  if (!userFingerPrint) {
    return;
  }

  const activeChatId = useNavigationState.getState().activeChatId;
  const setActiveChatRoleAsMember =
    useNavigationState.getState().setActiveChatRoleAsMember;

  const chatId = eventPayload.member.chat_id;
  const memberName = eventPayload.member.username;
  const memberRole = eventPayload.member.role;
  const isCurrentUser = userFingerPrint.username === memberName;

  if (isCurrentUser) {
    // update role inidexxed db
    await updateChatInLocalDB(chatId, {
      roleAsMember: {
        username: memberName,
        role: memberRole,
      },
    });
  }

  // if chat id is same as active chat id
  if (activeChatId === chatId) {
    if (isCurrentUser) {
      setActiveChatRoleAsMember(memberRole);
    }

    queryClient.invalidateQueries({
      queryKey: ["chat-members", activeChatId],
    });

    queryClient.invalidateQueries({
      queryKey: ["search-members"],
    });
  }
};
